export const getStudentPayments = async (studentId = null) => {
  try {
    const response = await fetch('/api/payments');
    if (!response.ok) {
      throw new Error('Failed to fetch payments');
    }
    const data = await response.json();
    
    if (studentId) {
      return data.filter(payment => payment.studentId === studentId);
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching payments:', error);
    return []; 
  }
};